import ayhanPic from "@/public/images/artists/ayhan.png";
import { Artist } from "@/types/types";

export const ayhan = {
  id: "184",
  name: "Ayhan",
  image: ayhanPic,
  description: `Ayhan is an experimental voice model with built-in distortion effects similar to those achieved by a guitar amp or analog gear. He delivers retro-style outputs reminiscent of recordings captured with classic broadcast mics. Ideal for adding texture to your projects.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fayhan-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Rock"],
      secondary: ["Experimental", "Processed"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 46,
        high: 68,
      },
      sweetSpot: 56,
    },
  },
} as const satisfies Artist;
